module.exports = __webpack_public_path__ + "p5_img3.jpg?c8571a714b222146796171ff223aad37";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p5/p5_img3.jpg
// module id = 179
// module chunks = 0